import React, { useEffect, useState } from 'react';

import * as rsuite from 'rsuite'
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, useNavigate, useParams } from "react-router-dom";
import * as General from '../../General/General';
import axios from 'axios';
import "bootstrap/dist/css/bootstrap.rtl.min.css";
import "rsuite/dist/rsuite-rtl.min.css";
import { MdOutlineMenu } from "react-icons/md";

const SharedTopic = ({ children }) => {

    //#region Constants
        let navigate = useNavigate();
    
    let { PId } = useParams();
    let { TId } = useParams();

    const [Nodes, setNodes] = useState([]);
    const [NodeId, setNodeId] = useState(General.GuidEmpty());
    const [Collapse, setCollapse] = React.useState(false);


    //#endregion Constants


    // #region Methods 

   


    useEffect(() => {
        console.log(PId);
    }, [])


    // #endregion 
    return (
       <div>
        {children}
       </div>
    );
}

export default SharedTopic;